<template>
    <Select
        v-model="model"
        :items="schedules"
        item-key="id"
        item-text="name"
        :placeholder="translate('admin_fights_manage.select_schedule_placeholder')"
        :dropdown-mode="dropdownMode"
    >
        <template v-slot:selected-item="{ selectedItem }">
            <div v-if="selectedItem">
                <span>{{ selectedItem.name }}</span>
                <span v-if="activeScheduleId && selectedItem.id === activeScheduleId" class="tag is-success ml-2">
                    {{ translate("admin_schedules_list.active") }}
                </span>
            </div>
        </template>
        <template v-slot:item="{ item }">
            <span>{{ item.name }}</span>
            <span v-if="activeScheduleId && item.id === activeScheduleId" class="tag is-success ml-2">
                {{ translate("admin_schedules_list.active") }}
            </span>
        </template>
    </Select>
</template>

<script setup lang="ts">
    import { translate } from "./translations";
    import Select from "./Select.vue";
    import { Schedule } from "./Schedule/types";

    const model = defineModel<number | undefined>();

    defineProps<{
        schedules: Schedule[];
        activeScheduleId?: number;
        dropdownMode?: "absolute" | "container";
    }>();
</script>

<style scoped></style>
